export const environment = {
  production: false,
  basePath: 'https://shuttlesalesdemoapi.mi2.in/api',
  v1basePath: 'https://shuttlesalesdemoapi.mi2.in/api',
  tenant: 'uil001',
  supportedCountry: [],
  fareFileId: 'd81da6026c01465ea580adceee67d16a.csv',
  scheduleFileId: 'c748ed958fd443d1a990b1c10be9b0df.csv',
};